import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M8.875 5a.75.75 0 0 1 0 1.5H7a1.75 1.75 0 0 0-1.75 1.75v10.625c0 .966.784 1.75 1.75 1.75h10a1.75 1.75 0 0 0 1.75-1.75V8.25A1.75 1.75 0 0 0 17 6.5h-1.873a.75.75 0 1 1 0-1.5H17a3.25 3.25 0 0 1 3.25 3.25v10.625a3.25 3.25 0 0 1-3.25 3.25H7a3.25 3.25 0 0 1-3.25-3.25V8.25A3.25 3.25 0 0 1 7 5zm3.127-3.124a.75.75 0 0 1 .75.75l-.001 10.689 2.47-2.47a.75.75 0 0 1 .977-.072l.084.073a.75.75 0 0 1 0 1.06l-3.75 3.75a.754.754 0 0 1-.53.22l.073-.004a.754.754 0 0 1-.044.003H12a.763.763 0 0 1-.413-.123.747.747 0 0 1-.117-.096l.079.069a.754.754 0 0 1-.079-.069l-3.75-3.75a.75.75 0 0 1 1.061-1.06l2.469 2.469V2.625a.75.75 0 0 1 .649-.742z' />
  </svg>
);
